<template>
  <div>
    <!--quizContent image-->
    <v-row justify="center" align="center">
      <v-col>
        <image-uploader
          id="quizContent-image"
          :maxWidth="1024"
          :maxHeight="512"
          :quality="0.9"
          :autoRotate="true"
          outputFormat="blob"
          :preview="false"
          :capture="false"
          accept="image/*"
          doNotResize="['gif', 'svg']"
          @input="onFileSelect"
        >
          <label for="quizContent-image" slot="upload-label">
            <!--quizContent image new-->
            <v-container
              v-if="isEditing && quizContentImageUrl"
              fluid
              class="pa-0"
              style="position: relative"
            >
              <v-img
                :src="quizContentImageUrl"
                :alt="getLocalisedValue(quizContent.title)"
                :max-height="quizContentImageHeight"
                cover
                style="border-radius: 7px"
              />

              <div style="position: absolute; bottom: 20px; right: 20px">
                <v-btn
                  small
                  color="error"
                  min-width="80"
                  class="rounded-1"
                  :disabled="isQuizContentImageSaving"
                  @click.prevent="cancelMediaSelection"
                >
                  {{ $t("course.courseDetails.cancel") }}
                </v-btn>
              </div>
            </v-container>

            <!--quizContent image existing-->
            <v-container
              v-else-if="hasContents(quizContent.images)"
              fluid
              class="pa-0"
              style="position: relative"
            >
              <v-img
                :src="getImage(quizContent.images)"
                :alt="getLocalisedValue(quizContent.title)"
                :max-height="quizContentImageHeight"
                cover
                style="border-radius: 7px"
                @click.prevent="() => {}"
              >
              </v-img>

              <div
                v-if="isEditing"
                class="v-btn v-size--small primary rounded-1 hand-cursor"
                style="position: absolute; bottom: 20px; right: 20px"
              >
                <v-icon left small color="white">mdi-pencil</v-icon>

                {{ $t("course.courseDetails.edit") }}
              </div>
            </v-container>

            <!--quizContent image empty-->
            <v-container
              v-else
              fluid
              class="fill-height justify-center pa-0"
              style="border: 1px solid #281166; border-radius: 7px"
              :style="`height: ${quizContentImageHeight}px`"
            >
              <div
                v-if="isEditing"
                class="
                  v-btn v-btn--outlined v-btn--plain
                  v-size--default
                  textLight--text
                  rounded-1
                  text-capitalize
                  hand-cursor
                "
                style="min-width: 120px; opacity: 0.5"
              >
                <v-icon left>mdi-upload-outline</v-icon>

                {{ $t("course.courseDetails.uploadCoverImage") }}
              </div>
            </v-container>
          </label>
        </image-uploader>
      </v-col>
    </v-row>

    <CropperModal ref="cropperModal" @croppedData="croppedData" />
  </div>
</template>

<script>
import CropperModal from "../../../core-module/components/CropperModal.vue";

export default {
  name: "QuizImage",
  components: {
    CropperModal,
  },
  props: {
    quizContent: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isQuizContentImageSaving: false,
      quizContentImage: null,
      quizContentImageUrl: null,
    };
  },
  computed: {
    quizContentImageHeight() {
      return this.$vuetify.breakpoint.xlOnly
        ? 400
        : this.$vuetify.breakpoint.lgAndUp
        ? 300
        : 250;
    },
  },
  watch: {
    isEditing() {
      this.cancelMediaSelection();
    },
  },
  methods: {
    onFileSelect(file) {
      this.quizContentImage = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        this.quizContentImageUrl = reader.result;
        this.$refs.cropperModal.show(this.quizContentImageUrl);
      };

      this.$emit("update:quizContent", {
        ...this.quizContent,
        quizContentImages: [{ url: this.quizContentImage }],
        hasChangesInImages: true,
      });
    },
    croppedData(blobData, base64Data) {
      this.quizContentImage = blobData;
      this.quizContentImageUrl = base64Data;

      this.$emit("update:quizContent", {
        ...this.quizContent,
        quizContentImages: [{ url: this.quizContentImage }],
        hasChangesInImages: true,
      });
    },
    cancelMediaSelection() {
      this.quizContentImage = null;
      this.quizContentImageUrl = null;

      const el = document.getElementById("quizContent-image");
      if (el) el.value = "";

      this.$emit("update:quizContent", {
        ...this.quizContent,
        quizContentImages: null,
        hasChangesInImages: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped />
